// @flow

import { sideMenuActions } from './sideMenuActionCreator';
import sideMenuConfig from '../sideMenuConfig';
import { checkAuthentication } from '../../../../services/helpers';

export const smStateConfigMap = {
  ZOOM_DASHBOARD: {
    key: 'My Dashboard', // init key
    list: null,
    wrapperClass: 'zoomDashboardWrapper',
    unselectedMenuClass: 'menuObj',
    selectedMenuClass: 'selectedMenuObj',
    selectedSubMenuClass: 'selectedSubMenuObj',
    unselectedSubMenuClass: 'subMenuObj'
  },
  SECOND_DASHBOARD: {
    key: 'ghanta key',
    list: null,
    wrapperClass: 'ghanta',
    unselectedMenuClass: 'ghanta',
    selectedMenuClass: 'ghanta',
    selectedSubMenuClass: 'ghanta',
    unselectedSubMenuClass: 'ghanta'
  },
  TEST_STATE: {
    key: 'Test',
    list: sideMenuConfig.SIDE_MENU_TEST,
    wrapperClass: 'testWrapperClass',
    unselectedMenuClass: 'testMenuObj',
    selectedMenuClass: 'testSelectedMenuObj',
    selectedSubMenuClass: 'testSelectedSubMenuObj',
    unselectedSubMenuClass: 'testSubMenuObj'
  }
};

const initialState = {};

export const getSideMenuListReducer = (listConfigObj: Object) => {
  // List to be generated by API in future
  const list = sideMenuConfig[listConfigObj.configKey];
  return list.filter(item => {
    if (!item.roles) {
      return true;
    } else if (
      item.roles &&
      checkAuthentication(item, listConfigObj.userProfile)
    ) {
      return true;
    }
    return false;
  });
};

export const updateSideMenuStyleReducer = stateToUpdate => {
  stateToUpdate.list.map(item => {
    item.expanded = false;
    item.className = stateToUpdate.unselectedMenuClass;
    if (!item.subMenu && item.key === stateToUpdate.key) {
      item.expanded = true;
      item.className = stateToUpdate.selectedMenuClass;
    } else if (item.subMenu) {
      item.subMenu.map(subMenuItem => {
        if (subMenuItem.key === stateToUpdate.key) {
          item.expanded = true;
          item.className = stateToUpdate.selectedMenuClass;
          subMenuItem.className = stateToUpdate.selectedSubMenuClass;
        } else {
          subMenuItem.className = stateToUpdate.unselectedSubMenuClass;
        }
        return subMenuItem; // eslint
      });
    }
    return item; // eslint
  });
};

export const updateSideMenuStateReducer = (
  currState: Object,
  stateUpdateObj: Object
) => {
  const updatedState = Object.assign({}, currState);
  const selectedMenuKey = !stateUpdateObj.menuKey.subMenu
    ? stateUpdateObj.menuKey.key
    : stateUpdateObj.menuKey.subMenu[0].key;
  updatedState.key = selectedMenuKey;
  updateSideMenuStyleReducer(updatedState);
  return updatedState;
};

export const SideMenuReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case sideMenuActions.GET_SIDEMENU_LIST:
      newState = Object.assign(
        {},
        state,
        smStateConfigMap[action.payload.configKey],
        {
          list: getSideMenuListReducer(action.payload)
        }
      );
      break;
    case sideMenuActions.SET_SIDEMENU_STATE:
      newState = Object.assign(
        {},
        state,
        updateSideMenuStateReducer(state, action.payload)
      );
      break;
    case sideMenuActions.UPDATE_SIDEMENU_STYLE:
      newState = Object.assign(updateSideMenuStyleReducer(action.payload));
      break;
    // case sideMenuActions.SEND_ANALYTICS_DATA:
    //   newState = Object.assign(sendAnalyticsDataReducer(action.payload));
    //   break;
    default:
      newState = state;
  }
  return newState;
};

export default SideMenuReducer;
